import React from 'react'

import { Meta } from './Meta'

export const DefaultMeta = () => (
  <Meta
    title="Mr Yum"
    description="Mr Yum helps you decide what to order. Beautiful, mobile menus with photos of every dish and language translations."
    openGraph={{
      title: 'Mr Yum',
      site_name: 'Mr Yum',
      description:
        'Mr Yum helps you decide what to order. Beautiful, mobile menus with photos of every dish and language translations.',
    }}
  />
)
